import { UnavailabilityError } from 'expo-modules-core';

export default function AdIconView() {
  throw new UnavailabilityError('expo-ads-facebook', 'AdOptionsView');
}
